import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import {
  KeycloakAngularModule,
  KeycloakAuthGuard,
  KeycloakEventType,
  KeycloakService,
} from 'keycloak-angular';
import { environment } from '../environments/environment';
import {PrimeNgModule} from "./primeng.module";

import { NgZorroModule } from './shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { DashboardModule } from './Horizon/Dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './Horizon/Layout/layout.module';
import { UserContext } from './shared/services/user-context.service';
import { FacebookModule } from './Horizon/Facebook/facebook.module';
import { AdminGuard } from './guards/admin.guard';
import { AnnotatorGuard } from './guards/annotator.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/http.interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InstagramModule } from './Horizon/Instagram/instagram.module';
import { TiktokModule } from './Horizon/Tiktok/tiktok.module';
import { YoutubeModule } from './Horizon/Youtube/youtube.module';
import { RedditModule } from './Horizon/Reddit/reddit.module';
import { TwitterModule } from './Horizon/Twitter/twitter.module';


export const initializeKeycloak = (keycloak: KeycloakService) => async () => {
  if (environment.keycloak.enable) {
    /**
     *  https://www.npmjs.com/package/keycloak-angular#keycloak-js-events
     *  The callback events from keycloak-js are available through a RxJS subject which is defined by keycloakEvents$.
     *  For example you make keycloak-angular auto refreshing your access token when expired
     * 
     **/
    keycloak.keycloakEvents$.subscribe({
      next(event) {
        if (event.type == KeycloakEventType.OnTokenExpired) {
          keycloak.updateToken(180);
        }
      },
    });
    return keycloak.init({
      config: {
        url: environment.keycloak.authority,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      // If set a false you cannot get any information about the user example the username
      // if you use keycloakService.getUserName() you get this error
      // User not logged in or user profile was not loaded.
      loadUserProfileAtStartUp: true,
      initOptions: {
        //   This is an action we specified on keycloak load
        //   We have two options : 'login-required'|'check-sso'
        //   If is set to 'login-required' this means your browser will do a full redirect to the Keycloak server and back to your application.

        // onLoad: 'login-required',
        // checkLoginIframe: true,

        //   If is set to  'check-sso'  instead this action will be performed in a hidden iframe, so your application resources only need to be loaded and parsed once by the browser.
        //   Then you will need to add the silentCheckSsoRedirectUri and create a html file   silent-check-sso.html with this content
        // <html>
        //    <body>
        //         <script>
        //           parent.postMessage(location.href, location.origin);
        //         </script>
        //      </body>
        // </html>
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/public/silent-check-sso.html',
        checkLoginIframe: false,
        redirectUri: environment.keycloak.redirectUri,
      },
      // By default the keycloak-angular library add Authorization: Bearer TOKEN to all http requests
      // Then to exclude a list of URLs that should not have the authorization header we need to provide  them here.
      bearerExcludedUrls: ['/public'],
    });
  }
};

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    KeycloakAngularModule, 
    FormsModule,
	  NgZorroModule,
    SharedModule,
    PrimeNgModule,
    LayoutModule,
    DashboardModule,
    FacebookModule,
    TwitterModule,
    InstagramModule,
    TiktokModule,
    YoutubeModule,
    RedditModule,
    FontAwesomeModule,
  ],
  providers: [
    //Initialize keyclaok service
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    { provide: APP_BASE_HREF, useValue: '/' },
	{
      provide: NZ_I18N,
      useValue: en_US
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    UserContext,
    AdminGuard,
    AnnotatorGuard,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

})
export class AppModule {}